import { extendTheme } from "@chakra-ui/react";

const colors = {
  brand: {
    50: "#f0faf3",
    100: "#d6f0de",
    200: "#aadebe",
    300: "#72c59a",
    400: "#3da975",
    500: "#22a45a",
    600: "#1a8a49",
    700: "#156f3b",
    800: "#0f5530",
    900: "#0B2027",
  },
  green: {
    50: "#f0faf3",
    100: "#d6f0de",
    200: "#aadebe",
    300: "#72c59a",
    400: "#3da975",
    500: "#22a45a",
    600: "#1a8a49",
    700: "#156f3b",
    800: "#0f5530",
    900: "#0B2027",
  },
};

const fonts = {
  heading: "'Afacad', sans-serif",
  body: "'Afacad', sans-serif",
};

const shadows = {
  card: "0 2px 12px rgba(0,0,0,0.08)",
  cardHover: "0 8px 32px rgba(0,0,0,0.14)",
  navbar: "0 2px 20px rgba(0,0,0,0.10)",
};

const components = {
  Button: {
    baseStyle: {
      fontWeight: 600,
      borderRadius: "0.5rem",
      transition: "all 0.2s",
    },
    variants: {
      solid: (props) => ({
        ...(props.colorScheme === "green" && {
          bg: "green.500",
          color: "white",
          _hover: { bg: "green.600", transform: "translateY(-1px)", boxShadow: "md" },
          _active: { bg: "green.700", transform: "none" },
        }),
      }),
      outline: (props) => ({
        ...(props.colorScheme === "green" && {
          borderColor: "green.500",
          color: "green.600",
          _hover: { bg: "green.50", borderColor: "green.600" },
        }),
      }),
      link: (props) => ({
        ...(props.colorScheme === "green" && {
          color: "green.600",
          fontWeight: 600,
          _hover: { color: "green.800", textDecoration: "none" },
        }),
      }),
    },
  },
  Card: {
    baseStyle: {
      container: {
        borderRadius: "1rem",
        boxShadow: "card",
        overflow: "hidden",
        transition: "all 0.25s",
        _hover: {
          boxShadow: "cardHover",
          transform: "translateY(-3px)",
        },
      },
    },
  },
  Heading: {
    baseStyle: {
      fontFamily: "'Afacad', sans-serif",
      fontWeight: 700,
    },
  },
  Input: {
    variants: {
      outline: {
        field: {
          borderRadius: "0.5rem",
          borderColor: "gray.200",
          _focus: { borderColor: "green.400", boxShadow: "0 0 0 1px var(--chakra-colors-green-400)" },
        },
      },
    },
    defaultProps: { variant: "outline" },
  },
  Select: {
    variants: {
      outline: {
        field: {
          borderRadius: "0.5rem",
          borderColor: "gray.200",
          _focus: { borderColor: "green.400", boxShadow: "0 0 0 1px var(--chakra-colors-green-400)" },
        },
      },
    },
    defaultProps: { variant: "outline" },
  },
  Textarea: {
    variants: {
      outline: {
        borderRadius: "0.5rem",
        borderColor: "gray.200",
        _focus: { borderColor: "green.400", boxShadow: "0 0 0 1px var(--chakra-colors-green-400)" },
      },
    },
    defaultProps: { variant: "outline" },
  },
  Badge: {
    baseStyle: { borderRadius: "0.4rem", fontWeight: 600 },
  },
  Table: {
    variants: {
      striped: {
        th: { fontFamily: "'Afacad', sans-serif", fontWeight: 700, letterSpacing: "0.03em" },
        td: { fontFamily: "'Afacad', sans-serif" },
      },
    },
  },
  Menu: {
    baseStyle: {
      list: {
        borderRadius: "0.75rem",
        boxShadow: "cardHover",
        border: "1px solid",
        borderColor: "gray.100",
        py: 2,
      },
      item: {
        fontFamily: "'Afacad', sans-serif",
        fontWeight: 500,
        _hover: { bg: "green.50", color: "green.700" },
        _focus: { bg: "green.50" },
      },
    },
  },
  Modal: {
    baseStyle: {
      dialog: { borderRadius: "1rem", boxShadow: "cardHover" },
      header: { fontFamily: "'Afacad', sans-serif", fontWeight: 700 },
    },
  },
};

const styles = {
  global: {
    "html, body": {
      bg: "gray.50",
      color: "gray.800",
      fontFamily: "'Afacad', sans-serif",
    },
    "*": { boxSizing: "border-box" },
  },
};

const config = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

const theme = extendTheme({
  colors,
  fonts,
  shadows,
  components,
  styles,
  config,
});

export default theme;
